export default function RegisterStepCompany({
    form,
    errors,
    branches,
    loadingBranches,
    loadingRuc,
    customerExists,
    handleChange,
    fetchRucData,
    setForm,
    setErrors,
    onNext
}) {

    return (
        <>
            <h1 className="text-xl font-semibold text-gray-800 -mt-4 hidden">
                Solicitud de Cliente
            </h1>
            <p className="text-sm text-gray-600 mt-1 mb-8 hidden">
                Complete el formulario. Un asesor validará su información.
            </p>

            <div className="space-y-8">

                {/* ================= DATOS EMPRESA ================= */}
                <section>
                    <h2 className="text-sm font-semibold text-gray-700 mb-0 uppercase -mt-4">
                        Datos de la empresa
                        <div className="border-b-2 border-gray-300 w-32 mb-5"></div>
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-[15%_85%] gap-4 -mt-2">

                        {/* ================= COLUMNA IZQUIERDA (35%) ================= */}
                        <div>
                            <Field label="RUC">
                                <input
                                    name="cedula"
                                    value={form.cedula || ""}
                                    maxLength={13}
                                    onChange={(e) => {
                                        // Solo números y máximo 13 caracteres
                                        const value = e.target.value.replace(/\D/g, "").slice(0, 13);
                                        handleChange({
                                            target: {
                                                name: "cedula",
                                                value
                                            }
                                        });
                                    }}
                                    onBlur={(e) => {
                                        const ruc = e.target.value.replace(/\D/g, "");
                                        if (ruc.length === 10 || ruc.length === 13) {
                                            fetchRucData(ruc);
                                        }
                                    }}
                                    className={`w-full border px-3 py-2 text-sm 
                                    ${errors.cedula ? "border-red-500" : "border-gray-300"}
                                    focus:outline-none focus:ring-0 focus:border-gray-500`}
                                />

                                {errors.cedula && (
                                    <p className="mt-1 text-xs text-red-600">
                                        {errors.cedula}
                                    </p>
                                )}

                                {loadingRuc && (
                                    <div className="mt-2 flex items-center gap-2 text-sm text-gray-500">
                                        <svg
                                            className="animate-spin h-4 w-4 text-gray-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            />
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                            />
                                        </svg>
                                        Consultando su información...
                                    </div>
                                )}
                            </Field>
                        </div>

                        {/* ================= COLUMNA DERECHA (65%) ================= */}
                        <div className="space-y-4">

                            <Field label="Razón social">
                                <input
                                    name="companyName"
                                    value={form.companyName || ""}
                                    onChange={handleChange}
                                    disabled={customerExists}
                                    maxLength={90}
                                    className={`w-full border px-3 py-2 text-sm
                                    ${errors.companyName ? "border-red-500" : "border-gray-300"}
                                    focus:outline-none focus:ring-0 focus:border-gray-500`}
                                />
                                {errors.companyName && (
                                    <p className="mt-1 text-xs text-red-600">{errors.companyName}</p>
                                )}
                            </Field>

                            <Field label="Dirección">
                                <input
                                    name="address"
                                    value={form.address || ""}
                                    disabled={customerExists}
                                    onChange={handleChange}
                                    maxLength={75}
                                    className={`w-full border px-3 py-2 text-sm
                                    ${errors.address ? "border-red-500" : "border-gray-300"}
                                    focus:outline-none focus:ring-0 focus:border-gray-500`}
                                />
                                {errors.address && (
                                    <p className="mt-1 text-xs text-red-600">{errors.address}</p>
                                )}
                            </Field>

                            <Field label="Ciudad">
                                <input
                                    name="city"
                                    value={form.city || ""}
                                    disabled={customerExists}
                                    onChange={handleChange}
                                    maxLength={21}
                                    className={`w-full border px-3 py-2 text-sm
                                    ${errors.city ? "border-red-500" : "border-gray-300"}
                                    focus:outline-none focus:ring-0 focus:border-gray-500`}
                                />
                                {errors.city && (
                                    <p className="mt-1 text-xs text-red-600">{errors.city}</p>
                                )}
                            </Field>

                            <Field label="Email">
                                <input
                                    type="email"
                                    name="eMail"
                                    value={form.eMail || ""}
                                    disabled={customerExists}
                                    onChange={handleChange}
                                    className={`w-full border px-3 py-2 text-sm
                                    ${errors.eMail ? "border-red-500" : "border-gray-300"}
                                    focus:outline-none focus:ring-0 focus:border-gray-500`}
                                />
                                {errors.eMail && (
                                    <p className="mt-1 text-xs text-red-600">{errors.eMail}</p>
                                )}
                            </Field>

                        </div>

                    </div>
                </section>


                {/* ================= CONTACTO ================= */}
                <section>

                    <h2 className="text-sm font-semibold text-gray-700 mb-2 uppercase -mt-12 -mb-4">
                        Contacto
                        <div className="border-b-2 border-gray-300 w-32 mb-5"></div>
                    </h2>

                    {/* 👇 2 columnas en desktop, 1 en móvil */}
                    <div className="grid grid-cols-1 md:grid-cols-[15%_85%] gap-4 -mt-2">

                        <Field label="Celular">
                            <input
                                name="fax"
                                value={form.fax || ""}
                                disabled={customerExists}
                                onChange={handleChange}
                                maxLength={24}
                                className={`w-full border px-3 py-2 text-sm
                                ${errors.fax ? "border-red-500" : "border-gray-300"}
                                focus:outline-none focus:ring-0 focus:border-gray-500`}
                            />
                            {errors.fax && (
                                <p className="mt-1 text-xs text-red-600">
                                    {errors.fax}
                                </p>
                            )}
                        </Field>
                        <Field label="Nombres">
                            <input
                                name="contactName"
                                value={form.contactName || ""}
                                onChange={handleChange}
                                disabled={customerExists}
                                maxLength={30}
                                className={`w-full border px-3 py-2 text-sm
                                ${errors.contactName ? "border-red-500" : "border-gray-300"}
                                focus:outline-none focus:ring-0 focus:border-gray-500`}
                            />
                            {errors.contactName && (
                                <p className="mt-1 text-xs text-red-600">
                                    {errors.contactName}
                                </p>
                            )}
                        </Field>


                    </div>
                </section>

                {/* ================= SUCURSAL ================= */}
                {branches.length > 1 && (
                    <section>


                        <div className="grid grid-cols-1 md:grid-cols-[15%_85%] gap-4 -mt-2">
                            <div>

                            </div>
                            {/* Select ocupa la primera columna */}
                            <div>
                                <h2 className="text-sm font-semibold text-gray-700 mb-0 uppercase -mt-2">
                                    Sucursal donde desea registrarse                                
                                </h2>
                                <select
                                    name="branchId"
                                    value={form.branchId || ""}
                                    disabled={customerExists}
                                    onChange={(e) => {
                                        const selectedBodegaId = e.target.value;
                                        const branch = branches.find(
                                            (b) => String(b.bodegaId) === String(selectedBodegaId)
                                        );
                                        if (!branch) return;

                                        setForm((prev) => ({
                                            ...prev,
                                            branchId: branch.bodegaId,
                                            bodegaId: branch.bodegaId,
                                            companyId: branch.companyId,
                                            firstId: branch.firstId,
                                        }));

                                        setErrors((prev) => ({ ...prev, branchId: undefined }));
                                    }}
                                    className={`w-full border px-3 py-2 text-sm
                                    ${errors.branchId ? "border-red-500" : "border-gray-300"}
                                    focus:outline-none focus:ring-0 focus:border-gray-500`}
                                >
                                    <option value="">Seleccione una sucursal</option>
                                    {branches.map((b) => (
                                        <option key={b.bodegaId} value={b.bodegaId}>
                                            {b.bodegaName}
                                        </option>
                                    ))}
                                </select>

                                {errors.branchId && (
                                    <p className="mt-1 text-xs text-red-600">
                                        {errors.branchId}
                                    </p>
                                )}
                            </div>

                            {/* Segunda columna para mensajes */}
                            <div className="flex items-center">
                                {loadingBranches && (
                                    <p className="text-xs text-gray-500">
                                        Cargando sucursales...
                                    </p>
                                )}
                            </div>

                        </div>
                    </section>
                )}

            </div>
        </>
    );
}

function Field({ label, children }) {
    return (
        <div className="w-full">
            <label className="block text-sm text-gray-700 mb-0 -mt-2 -mb-0">
                {label}
            </label>
            {children}
        </div>
    );
}
